import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import {
  getHDLaneRestrictionStyleClick,
  getHDLaneRestrictionStyleHover,
} from "../style/hdLaneRestriction";

export function getHDLaneRestrictionInteractions(layer, control) {
  const clickSelect = new Select({
    layers: [layer],
    condition: click,
    style: function (feature) {
      return getHDLaneRestrictionStyleClick(feature);
    },
  });
  clickSelect.on("select", function (e) {
    if (e.target.getFeatures().getLength() > 0) {
      control.set(
        "selectedFeatures",
        Array.from(e.target.getFeatures().getArray()),
      );
    } else {
      control.set("selectedFeatures", undefined);
    }
  });
  const hoverSelect = new Select({
    layers: [layer],
    condition: pointerMove,
    style: function (feature) {
      return getHDLaneRestrictionStyleHover(feature);
    },
  });

  return [clickSelect, hoverSelect];
}
